export default __webpack_public_path__ + "static/media/medical-care.37e1d230.png";